import React, { useState } from "react";
import TruckChart from "./TruckChart";
import {
  addMinuteToDateObject,
  getDefaultDate,
  getParsedPayloadAsTrucks,
} from "./Services/TruckDataService";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { payload2, solverPayload } from "./payload";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import "./App.css";

export default function TruckDataBody() {
  const [dateRange, onChange] = useState([
    getDefaultDate(),
    addMinuteToDateObject(1440),
  ]);

  return (
    <div>
      <div className="date-picker">
        <DateRangePicker onChange={onChange} value={dateRange} />
      </div>
      <div>
        <TruckChart
          truckList={getParsedPayloadAsTrucks(payload2)}
          dateRange={dateRange}
        />
      </div>
      <div>
        <p className="content-text">Our Optimized Solution</p>
        <TruckChart
          truckList={getParsedPayloadAsTrucks(solverPayload)}
          dateRange={dateRange}
        />
      </div>
    </div>
  );
}
